export default __webpack_public_path__ + "static/media/play-store-icon.d1d06c98.png";